import React from "react";
import { useTranslation } from "react-i18next";

import Spinner from "@/components/atoms/Spinner";
import HasMoreDataButton from "@/components/molecules/table/HasMoreDataButton";

export type HasMoreDataCellBaseProps = {
  displayValue?: string | undefined | null;
  hasMoreData: boolean;
  renderValue?: (value: string | null | undefined) => React.ReactNode;
  children?: React.ReactNode;
  isPending?: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

const HasMoreDataCellBase = ({
  displayValue,
  hasMoreData,
  renderValue = (value) => `${value}`,
  children,
  isPending,
  onOpenChange,
}: HasMoreDataCellBaseProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full items-center justify-between">
      <div className={"flex w-full justify-between gap-2 truncate"}>
        <div className="truncate">
          {displayValue ? renderValue(displayValue) : <span className={"text-quinary"}>{t("nothingFound")}</span>}
        </div>
        {isPending && (
          <div className={"px-2"}>
            <Spinner size={"2xs"} />
          </div>
        )}
      </div>
      {hasMoreData && <HasMoreDataButton onOpenChange={onOpenChange}>{children}</HasMoreDataButton>}
    </div>
  );
};

export default React.memo(HasMoreDataCellBase);
